import { render } from "./SocialMediaManagement.vue?vue&type=template&id=02ead2fa"
import script from "./SocialMediaManagement.vue?vue&type=script&lang=ts"
export * from "./SocialMediaManagement.vue?vue&type=script&lang=ts"
script.render = render

export default script